export const GOOGLE_CLIENT_ID = '116041353023-4umfms82fjfkfr6vkr3mubg4tr0k65g9.apps.googleusercontent.com';
export const FACEBOOK_APP_ID = '382238867303639';
export enum LoginStep {
  SelectMethod,
  SendPhoneCode,
  SendEmailCode,
  VerifyCode,
};
